const list = {
    or: 'o',
    and: 'e',
    separator: ',',
};
export default Object.freeze(list);
